/**
 *  Add data-toggle_modal="my-modal-id" to a button
 *  Add data-modal_id="my-modal-id" to an element
 *  An inner div is required in the modal element, see example below
 **/
let modal, overlay, modalId, closeBtn
function handleModal(e) {
    if (modal && modal.classList.contains('active')) {
        modal.classList.remove('active')
        modal.querySelector('.overlay').remove()
        modal.querySelector('.close-btn').remove()
        if (modal.querySelector('.gallery-full-img')) {
            modal.querySelector('.gallery-full-img').remove()
        }
    } else {
        modalId = e.target.dataset.toggle_modal
        modal = document.querySelector([`[data-modal_id="${modalId}"]`])
        const modalBody = modal.querySelector('div:last-child')

        overlay = /*html*/ `<div class="overlay fixed inset-0 bg-black/25" data-toggle_modal="${modalId}"></div>`

        closeBtn = /*html*/ `<button class="close-btn absolute flex items-center justify-center w-10 h-10 duration-150 rounded-full right-3 bg-black/20 hover:bg-black/5 active:bg-black/10 top-3" data-toggle_modal="${modalId}">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-white">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          
            </button>`

        if (e.target.classList.contains('gallery-img')) {
            const img_full_src = e.target.querySelector('img').dataset.full_src
            const fullImg = /*html*/ `<img src="${img_full_src}" class="gallery-full-img h-full object-contain">`
            modalBody.insertAdjacentHTML('afterbegin', fullImg)
        }

        modalBody.insertAdjacentHTML('afterbegin', closeBtn)
        modal.insertAdjacentHTML('afterbegin', overlay)
        modal.classList.toggle('active')
    }
}

document.addEventListener('click', (e) => {
    if (e.target.dataset.toggle_modal) {
        handleModal(e)
    }
})

document.addEventListener('keyup', (e) => {
    if (e.target.dataset.toggle_modal && e.key === 'Enter') {
        handleModal(e)
    }
})

/**
 * 
 * Example:
 * 
<button data-toggle_modal="login">Logga in</button>

<div class="flex items-center justify-center" data-modal_id="login">
    <div class="relative z-10 w-full max-w-lg p-4 bg-white rounded-lg md:p-6 lg:p-8">

    </div>
</div>
*/
